<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_ASSIGNEES" ppColor="primary-950"></pp-icon>
</div>

@if (isNewValue) {
  @if (assignedYou) {
    <span class="notification__blue-text">{{ 'you' | ppTranslate }}</span>
    {{ 'were' | ppTranslate }}
    <span class="notification__bold">{{ 'assigned_lowercase' | ppTranslate }}</span>
    {{ 'to_a_point' | ppTranslate }}.
  }
  @if (!assignedYou) {
    <span>
      <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
      {{ 'the_following' | ppTranslate }}
      <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
      {{ 'to_a_point_you' | ppTranslate }}
      {{ notificationReason }}:
    </span>
    <div class="notification__assignee-wrapper">
      @for (userId of ppNotification.changeBody.newValue; track userId) {
        @if (!ppNotification.changeBody?.oldValue.includes(userId)) {
          <img
            ppTooltip
            [ppTitle]="allUsers[userId] ? allUsers[userId].userName : 'Deleted user'"
            class="notification__assignee"
            [src]="allUsers[userId] ? allUsers[userId].avatarPublicUrl : EIconPath.PLACEHOLDER_USER"
            />
        }
      }
    </div>
  }
}

@if (isOldValue) {
  <span>
    <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
    {{ 'the_following' | ppTranslate }}
    <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}:
  </span>
  <div class="notification__assignee-wrapper">
    @for (userId of ppNotification.changeBody.oldValue; track userId) {
      @if (!ppNotification.changeBody?.newValue.includes(userId)) {
        <img
          ppTooltip
          [ppTitle]="allUsers[userId] ? allUsers[userId].userName : 'Deleted user'"
          class="notification__assignee"
          [src]="allUsers[userId] ? allUsers[userId].avatarPublicUrl : EIconPath.PLACEHOLDER_USER"
          />
      }
    }
  </div>
}
